import type { LinkToPayerEnum } from '@bambi/api-client/schemas';

export function getFinalPayerPassengerExternalId(
  linkToPayer: LinkToPayerEnum | null,
  insurancePolicyId?: string,
  currentPayerPassengerExternalId?: string
): string | undefined {
  // If we're linking the payer to passenger and it's an insurance payer
  // We use the policy id as the external id
  if (
    (linkToPayer === 'only_with_id' || linkToPayer === 'always') &&
    insurancePolicyId
  ) {
    return insurancePolicyId;
  }

  // We do nothing:
  // For brokers -- we use the current payer passenger external id already
  // For private payers -- there is no external id
  // If we're not linking -- we do nothing
  return currentPayerPassengerExternalId;
}
